import { DataModelTransitionData } from '../dataModelTransition';
import { MAIN_FIELD_TYPE, MainFieldType } from '../schemas';
import { getModelTransitionRowId } from './mainField';

/**
 * mainField に対応する行IDで OR 絞り込みする。
 * ID 未選択時は全件を返す。
 */
export const filterModelTransitionRowsByIds = (
  rows: DataModelTransitionData['rows'],
  selectedRowIds: readonly string[],
  mainField?: MainFieldType
): DataModelTransitionData['rows'] => {
  if (selectedRowIds.length === 0) {
    return rows;
  }

  const selectedRowIdSet = new Set(selectedRowIds);
  return rows.filter((row) => {
    const rowId = getModelTransitionRowId(row.queryParameter, mainField);
    return rowId !== undefined && selectedRowIdSet.has(rowId);
  });
};

/**
 * 検索結果テーブル（ヘッダ絞り込み前）に存在する SIS タイプコード。
 */
export const extractSisTypeCodesFromModelTransitionRows = (
  rows: DataModelTransitionData['rows']
): string[] => {
  const sisTypeCodes: string[] = [];
  for (const row of rows) {
    const rowId = getModelTransitionRowId(
      row.queryParameter,
      MAIN_FIELD_TYPE.TYPE
    );
    if (rowId != null && rowId !== '') {
      sisTypeCodes.push(rowId);
    }
  }
  return sisTypeCodes;
};
